import { feedbackProcessingDialog, killProcessingDialog } from '../components/dialogs/dialog.module.js';
import { removeAllErrorToolTips, showErrorToolTips } from '../components/dialogs/errorhandle.dialog.js';
import { openPaymentDialog } from '../components/payment/braintree.js';
import { sortByName } from '../helpers/helpers.js';
import { httpRequest } from './_http.api.service.js';
var preventAlertCreation = false;

export function createAlert(id_obj) {
    removeAllErrorToolTips();
    selectors.setSelectedAlert().then(function (obj) {
        feedbackProcessingDialog();
        preventAlertCreation = true;
        setTimeout(function () {
            $(".waiting-for-asset-box").remove();
            $("<div class='waiting-for-asset-box'><h5>" +I18n["wait_header"]+ "</h5>" +I18n["wait_dialog"]+"</div>").insertBefore("#searcharea");
        }, 5000);
        httpRequest("post", "alerts", obj).then(async (res) => {
            preventAlertCreation = false;
			$("body,html").toggleClass("wait");
			pageRefresh();
			BootstrapDialog.closeAll();
			
        }).catch((err) => {
            if (err.status == 402) {
                preventAlertCreation = false;
                killProcessingDialog();
                openPaymentDialog();   
            } else {
                preventAlertCreation = false;
                killProcessingDialog();
            }
        })
    }).catch(function (errors) {
        preventAlertCreation = false;
        showErrorToolTips(errors, errorcodes);
    });
}


var preventAlertEdit = false;

export function editAlert(id_obj) {
    removeAllErrorToolTips();
    var id = id_obj.alertid;
    selectors.setSelectedAlert(id).then(function (obj) {
        feedbackProcessingDialog();
        preventAlertEdit = true;
        $(".waiting-for-asset-box").remove();
        httpRequest("put", "alerts", obj).then(async (res) => {
            preventAlertEdit = false;
			$("body,html").toggleClass("wait");
			pageRefresh();
			BootstrapDialog.closeAll();
        }).catch((err) => {
            if (err.status == 402) {
                preventAlertEdit = false;
                killProcessingDialog();
                openPaymentDialog();   
            } else {
                preventAlertEdit = false;
                killProcessingDialog();
            }
        })
    }).catch(function (errors) {
        preventAlertEdit = false;
        showErrorToolTips(errors, errorcodes);
    });
}


export function deleteAlert(id_obj) {
	feedbackProcessingDialog();
	var id = id_obj.alertid;
	//var alertID = useralerts[id]['id'];
    httpRequest("delete", "alerts", [{id: id}]).then(async (res) => {
        preventAlertEdit = false;
        $("body,html").toggleClass("wait");
        pageRefresh();
        BootstrapDialog.closeAll();
    }).catch((err) => {
        killProcessingDialog();
    })
}


export function getAllAlertsFromServer(scope) {
	var loggedin = window.loggedin || '0';
	if (loggedin == '1') {
		return new Promise(function (resolve, reject) {

			var url = "/alerts";
			if (scope == "communityalerts") url = "/communityalerts";

			$.get(url, function (alerts_arr) {
				var alerts = 0;

				alerts = alerts_arr;

				/* clear useralert data */
				useralerts = [];
				var i = 0;

				for (var item in alerts) {

					var alert = alerts[item];

					var mockUserAlert = alert;

					var realDelta = false;
					if (alert.realdelta) realDelta = JSON.parse(alert.realdelta);

					/* check if Alert is active or not */
					var active = false;
					if (alert.type == "Alertdelta" && realDelta) {
						if (parseFloat(alert.delta) > 0 && parseFloat(alert.delta) <= parseFloat(realDelta.rising)) active = true;
						if (parseFloat(alert.delta) < 0 && parseFloat(alert.delta) >= parseFloat(realDelta.falling)) active = true;
					}
					if (alert.type == "Alertabsolute" && alert.lastPrice != "-") {
						if (alert.lessthan && parseFloat(alert.lastPrice) < parseFloat(alert.absolutevalue)) {
							active = true;
						}
						if (!alert.lessthan && parseFloat(alert.lastPrice) > parseFloat(alert.absolutevalue)) {
							active = true;
						}
					}

					mockUserAlert["active"] = active;

					/* inject Portfolio Data */
					var amount = 0;
					var startprice = 0;
					var name = "";
					var symbol = "";
					for (var asset in userassets) {
						if (userassets[asset].id == alert.asset_id) {
							amount = userassets[asset].amount;
							startprice = userassets[asset].startprice;
							name = userassets[asset].name;
							symbol = userassets[asset].symbol;
						}
					}

					mockUserAlert["amount"] = amount;
					mockUserAlert["startprice"] = startprice;

					if (!!alert.realdelta) mockUserAlert["realdelta"] = realDelta;

					useralerts.push(mockUserAlert);

				}

				/* sort by stockname */
				useralerts.sort(function (a, b) { return (sortByName((a.name ? a.name.toLowerCase() : "-"), (b.name ? b.name.toLowerCase() : "-"))) });

				/* add an index to it after sorting */
				for (let i = 0; i < useralerts.length; i++) useralerts[i]["index"] = i;

				if (alerts_arr) resolve();
				else reject();
			});
		});
	}
	return Promise.resolve();
}


